module.exports = __webpack_public_path__ + "static/icons/icon-caret-right-bold-5c4775d64e4b8b33b3454c4096a4f34d.svg";